import { Provider } from '@angular/core';
import { CompanyCollectorCommissionRuleRepository } from '@domain/company-collector-commission-rule/repositories/company-collector-commission-rule.repository';
import { CompanyCollectorCommissionRuleRepositoryService } from '../repositories/company-collector-commission-rule.service';

export const CompanyCollectorCommissionRuleProvider: Provider[] = [
  {
    provide: CompanyCollectorCommissionRuleRepository,
    useClass: CompanyCollectorCommissionRuleRepositoryService,
  },
];
